export default class EventShare {
    constructor (
        id,
        name,
        uri,
        expirationDate,
        eventId,
        dateOfOccurrence,
        description,
        device
    ) {
        this.id = id
        this.name = name
        this.uri = uri
        this.expirationDate = expirationDate
        this.eventId = eventId
        this.dateOfOccurrence = dateOfOccurrence
        this.description = description
        this.device = device
    }
}
